import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

/**
 * Retrieve blackout dates from the 3rd Party Blackout Dates APIs
 */
const getBlackoutDates = (
  selectedOrigin,
  selectedDestination,
  isRoundtrip,
  integrationSettings,
  meta,
  pageContext
) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__BLACKOUT_DATES: **integrationSettings** not especified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1BlackoutDates: blackoutDatesApiSettings } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = blackoutDatesApiSettings;

    if (
      !blackoutDatesApiSettings ||
      !blackoutDatesApiSettings.method ||
      !blackoutDatesApiSettings.endPoint
    ) {
      const MESSAGE = `INTEGRATION__BLACKOUT_DATES: **integrationSettings.blackoutDatesApiSettings** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    if (
      selectedOrigin &&
      selectedOrigin !== '' &&
      selectedDestination &&
      selectedDestination !== '' &&
      isRoundtrip !== undefined
    ) {
      axiosWrapper(
        {
          method: blackoutDatesApiSettings.method,
          url: `${blackoutDatesApiSettings.endPoint}`,
          headers: { ...blackoutDatesApiSettings?.headers },
          data: {
            origin: selectedOrigin,
            destination: selectedDestination,
            roundtrip: isRoundtrip
          }
        },
        {
          resource: 'INTEGRATION__BLACKOUT_DATES',
          meta,
          integrationSettings,
          pageContext,
          cache,
          cacheDuration
        }
      )
        .then((response) => {
          logger.info('INTEGRATION__BLACKOUT_DATES: Successful request', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          resolve({});
        });
    }
  });
};

export { getBlackoutDates };
